/**
 * An href/src is only allowed to be http(s) or a site-relative path.
 *
 * The API validates these fields on write (invalidLink in the backend), so a
 * hostile value cannot normally be stored. This is the second lock, and it is
 * the only one that covers LandingPreview, which renders what the admin is
 * typing before it has been anywhere near the server.
 */
export function safeUrl(value?: string | null): string | undefined {
  if (!value) return undefined;
  const v = value.trim();
  if (v.startsWith('/')) return v.startsWith('//') ? undefined : v;
  try {
    const u = new URL(v);
    return u.protocol === 'http:' || u.protocol === 'https:' ? v : undefined;
  } catch {
    return undefined;
  }
}
